import {inject, Injectable} from '@angular/core';
import {Router} from "@angular/router";
import {UserPreferencesService} from "../user-preferences.service";
import {UserPreferences} from "../../types/user-preferences.types";

@Injectable({
  providedIn: 'root'
})
export class RecordsTablePaginatorService {
  private userPreferencesService: UserPreferencesService = inject(UserPreferencesService);
  private router: Router = inject(Router);

  public isResourceInDropdownSettings(): boolean {
    return this.router.url.includes('dropdown-settings');
  }

  public getDefaultPageSize(): number {
    const userPreferences: UserPreferences | null = this.userPreferencesService.getUserPreferences();

    return userPreferences?.pageSize || (this.isResourceInDropdownSettings() ? 5 : 10);
  }
}
